// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Modal_buttonsContainer__DKO8-","containedButton":"Modal_containedButton__xOnlK","outlinedButton":"Modal_outlinedButton__lpmhV"};